export default "__VITE_ASSET___iYYV4By__"